__turbopack_context__.v({
  "band": "HowItWorks-module__vs2GWq__band",
  "block": "HowItWorks-module__vs2GWq__block",
  "blocks": "HowItWorks-module__vs2GWq__blocks",
  "bullet": "HowItWorks-module__vs2GWq__bullet",
  "bulletIcon": "HowItWorks-module__vs2GWq__bulletIcon",
  "bullets": "HowItWorks-module__vs2GWq__bullets",
  "container": "HowItWorks-module__vs2GWq__container",
  "label": "HowItWorks-module__vs2GWq__label",
  "reversed": "HowItWorks-module__vs2GWq__reversed",
  "step": "HowItWorks-module__vs2GWq__step",
  "stepNumber": "HowItWorks-module__vs2GWq__stepNumber",
  "text": "HowItWorks-module__vs2GWq__text",
  "title": "HowItWorks-module__vs2GWq__title",
  "visual": "HowItWorks-module__vs2GWq__visual",
});
